import React from 'react'
import logo from './images/logo.jpeg'
import './CSS/Latestupdates.css'

function Latestupdates() {
  return (
    <div><body class="latestupdates-body">
	<h1 class="latestupdates-h1">Latest Update</h1>
<ul class="latestupdates-cards">
  <li>
    <div href="" class="latestupdates-card">
      <img src="https://images.pexels.com/photos/9070106/pexels-photo-9070106.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500" class="latestupdates-card__image" alt="" />
      <div class="latestupdates-card__overlay">
        <div class="latestupdates-card__header">                    
          <img class="latestupdates-card__thumb" src={logo} alt="" />
          <div class="latestupdates-card__header-text">
          	<span class="latestupdates-tag latestupdates-tag-teal">Technology</span>
            <a><h3 class="latestupdates-card__title">Musk says TESLA will be out of money within 10 months</h3></a>           
            <span class="latestupdates-card__status">ADORE ENGLISH</span>
          </div>
        </div>
        <p class="latestupdates-card__description">Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, blanditiis</p>
      </div>
    </div>      
  </li>
  <li>
    <div href="" class="latestupdates-card">
      <img src="https://images.pexels.com/photos/8617899/pexels-photo-8617899.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500" class="latestupdates-card__image" alt="" />
      <div class="latestupdates-card__overlay">        
        <div class="latestupdates-card__header">                 
          <img class="latestupdates-card__thumb" src={logo} alt="" />
          <div class="latestupdates-card__header-text">
          	<span class="latestupdates-tag latestupdates-tag-purple">Popular</span>
            <a><h3 class="latestupdates-card__title">How to grow your Blog with viral content</h3></a>
            <span class="latestupdates-card__status">ADORE ENGLISH</span>
          </div>
        </div>
        <p class="latestupdates-card__description">Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, blanditiis</p>
      </div>
    </div>
  </li>
  <li>
  <div href="" class="latestupdates-card">
      <img src="https://images.pexels.com/photos/8617899/pexels-photo-8617899.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500" class="latestupdates-card__image" alt="" />
      <div class="latestupdates-card__overlay">        
        <div class="latestupdates-card__header">                 
          <img class="latestupdates-card__thumb" src={logo} alt="" />
          <div class="latestupdates-card__header-text">
          	<span class="latestupdates-tag latestupdates-tag-purple">Popular</span>
            <a><h3 class="latestupdates-card__title">How to grow your Blog with viral content</h3></a>
            <span class="latestupdates-card__status">ADORE ENGLISH</span>
          </div>
        </div>
        <p class="latestupdates-card__description">Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, blanditiis</p>
      </div>
    </div>
  </li>
</ul>
</body></div>
  );
}

export default Latestupdates